export const DATE_TIME_FORMAT = 'MM/DD/YYYY hh:mm A';
export const DATE_TIME_FORMAT_SERVER = 'YYYY-MM-DD HH:mm:ss';
export const SHOW_MONTH_NAME_FORMAT_WITH_TIME = 'MMMM DD, YYYY HH:mm:ss';
export const SHOW_MONTH_NAME_FORMAT = 'MMMM DD, YYYY';
export const UI_DATE_FORMAT = 'DD-MM-YYYY';
export const SERVER_DATE_FORMAT = 'YYYY-MM-DD'; 
export const DISPLAY_ONLY_DATE_FORMAT = 'MM-DD-YYYY';

export const isAcceptedStatus = (status) => {
	const finalStatus = String(status || '').toUpperCase().trim();
	return finalStatus === 'ACCEPTED' || finalStatus === 'CUSTOMER ACCEPTED' || finalStatus === 'SERVICE ACCEPTED PENDING';
};

export const getQuoteAmount = (quoteStatus , quotesData) => {
    if (!quotesData) return 'N/A';
    if(!!isAcceptedStatus(quoteStatus)){
        return quotesData?.amount_paid ? `USD ${quotesData?.amount_paid}` : 'N/A';
    }else{
        return quotesData?.quote ? `USD ${quotesData?.quote}` : 'N/A';  
    }
}

    